import { useState } from "react"
import { getCompetitors } from "../../api/api"
import { scoreTone } from "../../utils/seo"

export default function Competitors() {
  const [domain, setDomain] = useState("")
  const [data, setData] = useState(null)
  const [error, setError] = useState("")

  async function load() {
    setError("")
    try {
      const res = await getCompetitors(domain)
      setData(res.data)
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load competitor data")
    }
  }

  const competitors = data?.competitors || []
  const gapThemes = data?.gapThemes || []
  const opportunities = data?.keywordOpportunities || []

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Competitive Research</h1>
          <p className="muted">Competitor domains, topic gaps and keyword expansion ideas from your report data.</p>
        </div>
      </div>

      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={load}>Load competitors</button>
      </div>

      {error && <p className="error">{error}</p>}
      {data?.message && <p className="muted">{data.message}</p>}

      {data && (
        <div className="split-grid">
          <div className="card">
            <h2>Competitor Domains</h2>
            <div className="insight-list">
              {competitors.map((item) => (
                <div className="insight-item" key={item.domain}>
                  <strong>{item.domain}</strong>
                  <p className="muted">SERP competitor from configured provider data.</p>
                </div>
              ))}
              {competitors.length === 0 && <div className="empty-state">No live competitor domains yet.</div>}
            </div>
          </div>

          <div className="card">
            <h2>Gap Themes</h2>
            <div className="cluster-list">
              {gapThemes.map((cluster) => (
                <div className="cluster-card" key={cluster.topic}>
                  <div className="score-bar-top">
                    <strong>{cluster.topic}</strong>
                    <span className={`status ${scoreTone(cluster.potential)}`}>{cluster.potential || 0}/100</span>
                  </div>
                  <p className="muted">{(cluster.keywords || []).slice(0, 10).join(", ")}</p>
                </div>
              ))}
              {gapThemes.length === 0 && <div className="empty-state">No gap themes yet.</div>}
            </div>
          </div>

          <div className="card">
            <h2>Expansion Keywords</h2>
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Keyword</th>
                    <th>Intent</th>
                    <th>Potential</th>
                    <th>Page Type</th>
                  </tr>
                </thead>
                <tbody>
                  {opportunities.slice(0, 15).map((item) => (
                    <tr key={item.keyword}>
                      <td><strong>{item.keyword}</strong></td>
                      <td>{item.intent}</td>
                      <td><span className={`status ${scoreTone(item.potential)}`}>{item.potential}/100</span></td>
                      <td>{item.recommendedPageType}</td>
                    </tr>
                  ))}
                  {opportunities.length === 0 && (
                    <tr>
                      <td colSpan="4" className="muted">No expansion keywords yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
